import { grey } from "@material-ui/core/colors";
import { fade, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "400px",
    height: "min-content",
  },
  content: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    paddingBottom: theme.spacing(5),
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    height: "100%",
    paddingTop: theme.spacing(3),
    borderRadius: theme.spacing(1),
    border: `1px solid ${grey[300]}`,
  },
  secondFactorPaper: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  signInText: {
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: theme.spacing(3),
    lineHeight: `${theme.spacing(3)}px`,
    margin: theme.spacing(2, 0, 1, 0),
  },
  verifyText: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.grey[600],
    textAlign: "center",
  },
  rememberDeviceLabel: {
    fontSize: "13px",
  },
  passkeyButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover": {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.buttonHover.main,
      boxShadow: `0px 2px 2px ${theme.palette.grey[300]}, 0px 1px 5px ${theme.palette.grey[200]}`,
    },
    padding: theme.spacing(0, 3),
    height: theme.spacing(5),
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  continueRow: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  secondFactorLinksRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    width: "100%",
  },
  secondFactorLink: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 14,
    textDecoration: "underline",
    textTransform: "none",
    paddingInline: theme.spacing(0.3),
  },
  secondFactorLinkDot: {
    color: theme.palette.primary.main,
  },
  backToLoginLink: {
    color: grey[500],
    fontSize: 14,
    textTransform: "none",
  },
  methodList: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    width: "100%",
  },
  methodRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    width: "100%",
    height: 56,
    padding: theme.spacing(0, 1.5),
    borderRadius: theme.spacing(1),
    backgroundColor: grey[50],
    textAlign: "left",
    transition: theme.transitions.create("background-color"),
    "&:hover": {
      backgroundColor: grey[100],
    },
  },
  methodIconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 40,
    height: 40,
    borderRadius: theme.spacing(1),
    backgroundColor: fade(theme.palette.primary.main, 0.08),
    color: theme.palette.primary.main,
  },
  methodContent: {
    flex: 1,
    minWidth: 0,
  },
  methodTitle: {
    color: theme.palette.common.black,
    fontSize: 16,
  },
  methodArrow: {
    color: theme.palette.primary.main,
  },
  recoveryBtn: {
    textTransform: "initial",
    textDecoration: "underline",
  },
}));

export default useStyles;
